import React, { useEffect, useState } from 'react'
import Downshift from 'downshift'
import { FormField } from '../../atoms'
import FormInput from '../../atoms/FormInput/FormInput'
import LoadingSvg from '../../atoms/Loading/Loading'
import { api } from '../../../utils'

const AutoComplete = ({
  label,
  placeholder,
  inputFromProps,
  items: itemsFromProps,
  onChange,
  async,
  limit,
  loading,
  onBlur,
  status,
  errorMessage,
  customInput,
  onlyOptionsInput,
  id,
}) => {
  const [items, setItems] = useState(itemsFromProps ? itemsFromProps : [])
  const [input, setInput] = useState('')

  useEffect(() => {
    inputFromProps && setInput(inputFromProps)
  }, [inputFromProps])

  useEffect(() => {
    async && setItems(itemsFromProps)
  }, [itemsFromProps])

  return (
    <Downshift
      onInputValueChange={(inputValue) => onChange && (onChange(inputValue), setInput(inputValue))}
      onChange={(selection) => {
        setInput(selection?.value)
        onChange && onChange(selection?.value, selection)
      }}
      itemToString={(item) =>
        onlyOptionsInput
          ? item
            ? item.value
            : ''
          : item
          ? input === item?.value
            ? item?.value
            : input
          : input
      }
    >
      {({
        getInputProps,
        getItemProps,
        getLabelProps,
        getMenuProps,
        getToggleButtonProps,
        isOpen,
        inputValue,
        highlightedIndex,
        selectedItem,
        getRootProps,
      }) => (
        <div className="autocomplete">
          <FormField {...getLabelProps()} label={label} errorMessage={errorMessage} status={status} id={id}>
            <div {...getRootProps({}, { suppressRefError: true })} {...getToggleButtonProps()}>
              {customInput ? (
                customInput
              ) : (
                <FormInput
                  onBlur={onBlur}
                  {...getInputProps({
                    value: inputFromProps === undefined ? (input ? input : '') : inputFromProps,
                  })}
                  placeholder={placeholder}
                  id={id}
                />
              )}
            </div>
          </FormField>
          {items !== null && (
            <ul {...getMenuProps()} className="autocomplete__items">
              {isOpen ? (
                loading ? (
                  <LoadingSvg width={20} />
                ) : (
                  items?.length > 0 &&
                  items
                    ?.filter((item) => !inputValue || item.value.includes(inputValue))
                    .slice(0, limit ? limit : items?.length)
                    .map((item, index) => (
                      <li
                        {...getItemProps({
                          autoComplete: true,
                          key: item.value,
                          index,
                          item,
                          style: {
                            cursor: 'pointer',
                            backgroundColor: highlightedIndex === index ? 'lightgray' : 'white',
                            fontWeight: selectedItem === item ? 'bold' : 'normal',
                          },
                        })}
                      >
                        {item.value}
                      </li>
                    ))
                )
              ) : null}
            </ul>
          )}
        </div>
      )}
    </Downshift>
  )
}

export default AutoComplete

// Custom Hook per rendere pulito tailormade
export const useAutocomplete = (value) => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState()
  const [data, setData] = useState()

  const _fetchItems = async (input, product) => {
    setLoading(true)
    let params = {
      q: input,
      product,
    }
    await api
      .get(`/autocomplete/`, { params })
      .then((res) => {
        setData(res?.data)
        setLoading(false)
      })
      .catch((err) => {
        setError(err?.message), setLoading(false)
      })
    setLoading(false)
  }

  useEffect(() => {
    const timeout = setTimeout(() => {
      value && _fetchItems(value)
    }, 500)
    return () => (clearTimeout(timeout), setLoading(false))
  }, [value])

  const fetchItems = async (input, product = 0) => {
    setLoading(true)
    await _fetchItems(input, product)
    setLoading(false)
    return data
  }

  return { data, loading, error, fetchItems }
}
